import styles from "./Footer.module.scss";
import Image from "../Image";
import Link from "next/link";

function Footer({ data = {} }) {
  const { copy, logo, nav, socials } = data;

  return (
    <footer className="relative flex flex-col bg-brand-blue-600">
      {logo && (
        <div className="absolute top-0 left-0 w-fit bg-brand-orange-500 rounded-full rounded-tl-none py-8 px-[4.3125rem] flex justify-center">
          <Image
            src={logo.permalink}
            alt="Company Logo"
            width={logo.width}
            height={logo.height}
          />
        </div>
      )}
      <div className="w-full lg:flex lg:justify-end lg:w-11/12 lg:self-end bg-brand-turquoise-500 pt-[10.5rem] px-4 py-6 lg:pt-11 rounded-bl-[3.75rem] sm:rounded-br-[3.75rem] md:rounded-b-[9rem]">
        <div className="sm:flex lg:w-8/12 sm:justify-between md:px-32 lg:pl-0">
          {copy && (
            <div
              className="mb-6"
              dangerouslySetInnerHTML={{ __html: copy }}
              tabIndex="0"
            />
          )}
          {socials?.length > 0 && (
            <div className="flex items-center justify-end gap-4">
              {socials.map((item, i) => (
                <Link key={i} href={item.link} passHref>
                  <a target="_blank" rel="noopener noreferrer">
                    <Image
                      className={styles.image}
                      alt={item.icon?.alt || "Social Media Icon"}
                      src={item.icon?.permalink}
                      width={item.icon?.width}
                      height={item.icon?.height}
                    />
                  </a>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>

      {nav && nav.length > 0 && (
        <div className="flex justify-end px-8 pt-3 pb-4 text-white">
          {nav.map((link, index) => {
            const { url, title } = link;

            if (url && title) {
              return (
                <div key={index} className="flex">
                  <a href={url}>{title}</a>
                  <div className="mx-2">|</div>
                </div>
              );
            }
          })}
          <div className="flex">
            <button
              type="button"
              id="hs_show_banner_button"
              onClick={() => {
                var _hsp = (window._hsp = window._hsp || []);
                _hsp.push(["showBanner"]);
              }}
            >
              Datenschutzeinstellungen
            </button>
          </div>
        </div>
      )}
    </footer>
  );
}

export default Footer;
